import React from 'react'

import type { MuiTheme as Theme } from '@paintscout/ui'
import { makeStyles } from '@paintscout/ui'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  fill: {
    fill: theme.palette.primary.main
  },
  fillWhite: {
    fill: '#fff'
  },
  paper: {
    fill: '#fff',
    stroke: theme.palette.primary.main,
    strokeWidth: 5
  }
}))

export default function CoverThumbnail({ ...props }) {
  const classes = useStyles(props)

  return (
    <svg viewBox="0 0 150 200">
      <rect x={0} y={25} width={150} height={150} className={classes.fill} />

      <rect x={120} y={80} width={20} height={20} className={classes.fillWhite} />
      <rect x={100} y={110} width={40} height={20} className={classes.fillWhite} />
      <rect x={100} y={140} width={40} height={20} className={classes.fillWhite} />
    </svg>
  )
}
